import { BarChart3, ArrowRight } from "lucide-react";
import Stats from "../components/zenith/stat/Stats";
import { useNavigate } from "react-router-dom";
import TrafficChart from "../components/zenith/chart/TrafficChart";

interface TrafficData {
  total_sent: number;
  total_delivered: number;
  total_pending: number;
  total_failed: number;
  total_absent_from_network: number;
  invalid: number;
  total_delivered_to_network: number;
}
const DashboardPage = () => {
  const navigate = useNavigate();

  // Traffic data from the report
  const trafficData: TrafficData = {
    total_sent: 15040,
    total_delivered: 5040,
    total_pending: 101405,
    total_failed: 11154,
    total_absent_from_network: 7448,
    invalid: 5,
    total_delivered_to_network: 4000,
  };

  return (
    <div className="w-full bg-gray-50 p-6 rounded-xl">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
        <div>
          <div className="flex items-center gap-3">
            <div className="bg-red-600 p-2 rounded-lg">
              <BarChart3 className="h-6 w-6 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-800">Today's Report</h1>
          </div>
          <p className="text-sm text-gray-500 mt-2 ml-11 capitalize">
            Account Cumulated Traffic Report -{" "}
            {new Date().toLocaleDateString("en-GB")}
          </p>
        </div>
        <button
          onClick={() => navigate("/dashboard/past-reports")}
          className="flex items-center px-5 py-2.5 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors shadow-md hover:shadow-lg ml-0 md:ml-auto"
        >
          View Past Reports
          <ArrowRight className="ml-2 h-4 w-4" />
        </button>
      </div>

      {/* Stats Cards */}
      <Stats />

      {/* Traffic Chart Component */}
      <TrafficChart trafficData={trafficData} />
    </div>
  );
};

export default DashboardPage;
